module.exports = __webpack_public_path__ + "static/media/Fantasy_main_t.9c86deb7.jpg";